import Alpine from "alpinejs";
import { t } from "../helpers";

Alpine.data("addToCartForm", () => ({
  working: false,

  events: {
    ["x-on:cart:added.window"]() {
      this.working = false;
    },
    ["x-on:cart:adding.window"]() {
      this.working = true;
    },
    ["x-on:submit.prevent"]() {
      this.addToCart();
    },
  },

  get canAddToCart() {
    return this.variant.available;
  },
  get variant() {
    return Alpine.store("variant");
  },
  get product() {
    return Alpine.store("product");
  },

  addToCart() {
    let formData = new FormData(this.$root);
    let quantity = formData.get("quantity");

    Shopify.cart
      .add(parseInt(this.variant.id), parseInt(quantity || 1))
      .then((e) => {
        this.$dispatch("added-to-cart-modal:show", {
          productName: this.product.title,
          productOptions:
            this.variant.title === "Default Title" ? null : this.variant.title,
          productPrice: this.variant.price * quantity,
        });
      })
      .catch((error) => {
        this.$dispatch(
          "toast:show",
          {
            message: error.message,
            type: "error",
          },
          true,
        );
      });
  },
}));
